module.exports = __webpack_public_path__ + "static/img/h4.45f832c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/hor/h4.jpg
// module id = FONM
// module chunks = 1